import { Observable, throwError } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WordpressPaging } from '@app/enums/_index';
import { StaticPageInterface } from '@app/interfaces/_index';
import { getCacheBustedParams } from '@app/utilities/cacheBustedHttpParams.utilities';
import { environment } from '@environments/environment';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../shared/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class StaticPageService extends ErrorHandlerService {
  private beyondCXURL = `${environment.cms.url}/wp-json/wp/v2/pages`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Returns the quick start guide from the Wordpress API
   * @param slug - subscription slug string
   * @returns - Static CMS page observable response
   * TODO: Refactor this since it is being used in multiple places
   */
  getStaticPageDetail(slug: string): Observable<StaticPageInterface[]> {
    const contentParams = getCacheBustedParams()
      .append('slug', slug)
      .append(WordpressPaging.PER_PAGE_KEY, WordpressPaging.PER_PAGE_VALUE);
    return this.http.get(`${this.beyondCXURL}`, { params: contentParams }).pipe(
      catchError((err) => {
        console.log(`Service error has occurred`, err);
        return throwError(() => new Error(err));
      }),
      catchError(this.handleError<StaticPageInterface[]>(`get ${slug} detail static page`, []))
    );
  }
}
